export const resolveStatsTag = (statisticsObj, fallback) => {
    if (statisticsObj && statisticsObj.statistics === false) return null;

    const explicit =
        statisticsObj && typeof statisticsObj.statisticsId === "string" && statisticsObj.statisticsId.trim();

    if (explicit) return explicit;

    const fb = typeof fallback === "function" ? fallback() : fallback;
    return fb || null;
};
